<template>
  <div id="informationConfirmOfPerMonth">
    <div class="Grid85004776">
      <div class="Grid3CFB3B2B">
        <div>
          <md-field-item
            :content="proInfo.ccy"
            :title="'存入币种'"
            :solid="true"
            :align="'right'"
          >
          </md-field-item>
        </div>
        <div>
          <md-field-item
            :title="$t('label.label99')"
            :content="proInfo.depositTerm"
            :solid="true"
            :align="'right'"
          >
          </md-field-item>
        </div>
        <div>
          <md-field-item
            :content="proInfo.buyBaseAcctNo"
            :title="$t('label.label100')"
            :solid="true"
            :align="'right'"
          >
          </md-field-item>
        </div>
        <div>
          <md-field-item
            :title="$t('label.label110')"
            :content="proInfo.payMoney"
            :solid="true"
            :align="'right'"
          >
          </md-field-item>
        </div>
        <div>
          <md-field-item
            :content="proInfo.SelectorBoxB14D"
            :title="$t('label.label111')"
            :solid="true"
            :align="'right'"
          >
          </md-field-item>
        </div>
      </div>
      <div class="Grid3BD34410">
        <span text="'存入金额（元）'" class="textF0892176">
           {{$t('label.label101')}}
        </span>
        <md-field-item
          :type="'money'"
          :content="$commafy(proInfo.tranAmt)"
        />
      </div>
      <div class="GridE89DD886">
        <div>
          <md-field-item
            :content="proInfo.ccy+this.$commafy(proInfo.availableBalance)"
            :title="$t('label.label105')"
            :solid="true"
            :align="'right'"
          >
          </md-field-item>
        </div>
        <div>
          <md-field-item
            :content="proInfo.ccy+this.$commafy(incomeMoney)"
            :title="$t('label.label188')"
            :solid="true"
            :align="'right'"
          >
          </md-field-item>
        </div>
      </div>
      <div class="Grid39DAC6A9">
        <md-button :text="'确定'" :type="'primary'" :round="true" @click="dualAuthentication">{{$t('btn.btn1')}}</md-button>
      </div>
    </div>
  </div>
</template>
<script>
import { FieldItem, Button } from '@gidc/mobile'
import { mapGetters } from 'vuex'
import { PREPURINTTRICAL, PRODUCTPAY, SMARTDEPOSITDUALAUTH } from '../../api/smartdeposit'
export default {
  name: 'informationConfirmOfPerMonth',
  components: {
    [FieldItem.name]: FieldItem,
    [Button.name]: Button
  },
  computed: {
    ...mapGetters([
      'RnInfo',
      'headerInfo',
      'proInfo'
    ])
  },
  watch: {
    headerInfo: function (newval, oldval) {
      console.log("newval.headers['x-business-token']", newval.headers['x-business-token'])
      this.dualAuthenticationSecond(newval.headers['x-business-token'])
    }
  },
  data () {
    return {
      incomeMoney: '' // 预期收益
    }
  },
  methods: {
    getInterest () {
      const params = {
        prodType: 'FP01060001', // 产品类型日日赚：FP01060005，月月高：FP01060002
        ccy: this.proInfo.ccy, // 币种
        tranAmt: this.proInfo.tranAmt, // 金额
        startDate: '', // 起存日期
        depositTerm: this.proInfo.depositTermValue, // 存期
        agreementAmt: this.proInfo.payMoney, // 供款金额FP01060001零存整取智能存款上送
        floatValue: '', // 浮动值
        targetAmt: ''
      }
      this.$remote.post(PREPURINTTRICAL + '?_locale=' + this.$exchangeLang(this.RnInfo.language), params, { headers: { _token_name: this.RnInfo.token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
        .then(res => {
          this.incomeMoney = res.intTotal
        })
    },
    dualAuthentication () {
      const params = {
        _token_name: this.RnInfo.token
      }
      this.$remote.post(SMARTDEPOSITDUALAUTH + '?_locale=' + this.$exchangeLang(this.RnInfo.language), params, { headers: { _token_name: this.RnInfo.token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
        .then(res => {
          if (res.bodyMap.code === '418') {
            window.emitRNFunction('authentication', res.bodyMap.data.strategys[0])
          }
        })
    },
    dualAuthenticationSecond (token) {
      const params = {
        _token_name: this.RnInfo.token
      }
      this.$remote.post(SMARTDEPOSITDUALAUTH + '?_locale=' + this.$exchangeLang(this.RnInfo.language), params, { headers: { _token_name: this.RnInfo.token, xBusinessToken: token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
        .then(res => {
          if (res.status === '200') {
            this.buyPro()
          }
        })
    },
    buyPro () {
      const params = {
        serviceCode: 'MBSD_BP_BS', // 服务领域
        messageType: '1000', // 服务类型
        messageCode: '0016', // 服务编码
        prodType: 'FP01060001', // 产品类型
        depositTerm: this.proInfo.depositTermValue, // 存期
        buyBaseAcctNo: this.proInfo.buyBaseAcctNo, // 购买账号
        withdrawBaseAcctNo: this.proInfo.buyBaseAcctNo, // 到期自动赎回账号
        tranAmt: this.proInfo.tranAmt, // 购买金额
        ccy: this.proInfo.ccy, //
        userAccountId: this.proInfo.accID,
        agreementAcctNo: this.proInfo.ContributionACCId, // 供款账号
        agreementAmt: this.proInfo.payMoney // 供款金额
      }
      this.$remote.post(PRODUCTPAY + '?_locale=' + this.$exchangeLang(this.RnInfo.language), params, { headers: { _token_name: this.RnInfo.token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
        .then(res => {
          this.$router.push({ name: 'transactionResult', params: { tranAmt: this.proInfo.tranAmt, baseAcctNo: res.baseAcctNo, status: true } })
        })
        .catch(err => {
          console.log('cuwuo')
          this.$router.push({ name: 'transactionResult', params: { msg: err.msg, status: false } })
        })
    },
    initData () {
      // prodType = this.proInfo.prodType, // 产品类型
      // depositTerm = this.proInfo.depositTerm, // 存期
      // ccy = this.proInfo.ccy, // 币种
      // buyBaseAcctNo = this.proInfo.buyBaseAcctNo, // 购买账号
      // tranAmt = this.proInfo.tranAmt, // 购买金额
      // payMoney = this.proInfo.payMoney, // 供款金额
      // Agree8723 = this.proInfo.Agree8723,
      // SelectorBoxB14D = this.proInfo.SelectorBoxB14D, // 供款账号
      // payAcctNo = this.proInfo.payAcctNo
    }
  },
  mounted () {
    this.getInterest()
  }
}
</script>
<style lang="stylus">
  #informationConfirmOfPerMonth{
    .Grid85004776{
      .Grid3CFB3B2B,.GridE89DD886{
        .md-field-item{
          .md-field-item-content{
            min-height .92rem
            height .92rem
            .md-field-item-title{
              font-size .28rem
              font-weight 400
              color #1E1E1E
              line-height .4rem
              text-align left
              white-space nowrap
            }
            .md-field-item-control{
              height .4rem
              font-size .28rem
              font-weight 400
              color #333333
              line-height .4rem
              input{
                height 40px
                font-size 28px
                font-weight 400
                color #333333
                line-height 40px
                text-align right
              }
              input::placeholder {
                      color #999999
                      font-weight 400
                      font-size .28rem
                      height .4rem
                      line-height .4rem
                    }
              .md-field-item-placeholder{
                height .4rem
                font-size .28rem
                font-weight 400
                color #999999
                line-height .4rem
              }
            }
          }
        }
      }
      .Grid3BD34410{
        .md-field-item{
          padding .3rem 0
          .md-field-item-content{
            height .4rem
            min-height .4rem
            .md-field-item-control{
              padding 0 .3rem
              .md-input-item-input{
                font-weight 400
                color #333333
                font-size .28rem
                height .4rem
                line-height .4rem
              }
              input::placeholder {
                color #999999
                font-weight 400
                font-size .28rem
                height .4rem
                line-height .4rem
              }
            }
          }
          .md-field-item-content::before{
            content none
          }
        }
      }
      .Grid39DAC6A9{
        .md-button{
          height .92rem
          min-height .9rem
          .md-button-inner{
            .md-button-content{
              height .5rem
              font-size .36rem
              font-weight 500
              color #FFFFFF
              line-height .5rem
            }
          }
        }
        .md-button.primary{
          background linear-gradient(135deg, #4792F7 0%, #2B80F4 100%)

          border-radius .46rem
        }
      }
    }
  }

</style>
<style lang="stylus" scoped>
  #informationConfirmOfPerMonth{
    .Grid85004776{
      .Grid3CFB3B2B,.GridE89DD886{
        padding 0 .3rem
      }
      .Grid3BD34410{
        position relative
        padding .3rem .3rem 0
        .textF0892176{
          font-size .28rem
          display block
          font-weight 400
          height .4rem
          line-height .4rem
          color #1E1E1E
        }
        .GridE89DD886{
          display flex
          .text6D2D4F7E{
            display inline-block
            font-size .24rem
            height .33rem
            font-weight 400
            color #999999
            line-height .33rem
          }
          .spanRight{
            padding-left .2rem
          }
        }
      }
      .Grid3BD34410::after{
        position absolute
        bottom 0
        content ''
        width 92%
        height .02rem
        background #ECECEC
      }
      .GridCB5CCE6B{
        font-size .2rem
        font-weight 400
        color #999999
        line-height .28rem
        padding .3rem
      }
      .Grid39DAC6A9{
        padding .6rem .3rem .3rem
      }
    }
  }
</style>
